import sdk from '@crossmarkio/sdk'
import { HoverOption } from "../../MenuOptions/MenuOptionsElements";
import { useModal } from "../../Modal/ModalContext";
import LoadingScreen, { ModalLoadingScreen } from "../../LoadingScreen";
import {
  ALERT_TYPES,
  TRANSACTION_OPTIONS,
  WALLET_TYPES,
} from "../../../utils/Enum";
import axiosInstance from "../../Authorization/client";
import OptionModal from "../../OptionModal";
import { useAuth } from "../../../contexts/AuthContext";
import { useEffect, useState } from "react";
import { useAlert } from "../../Alert/AlertContext";
import {
  getSignTxStatus,
  updateSignTxStatus,
} from "../../../utils/dbUtils/signTxUtils";
import useArtist from "../../../hooks/useArtist";
import { Form, FormButton, FormContent, FormH1, FormText, FormWrapper } from "../../CustomForm/CustomFormElements";
import { useWebsiteTheme } from "../../WebsiteTheme/WebsiteThemeContext";
import { hexToStr } from "../../../utils";
const axios = axiosInstance;
const CrossMark = ({ type, body, heading, onCancel, onSuccess, onFail }) => {
  const { openModal, modalContent, closeModal } = useModal();
  const { artistProfileChecker } = useArtist({
    id: body?.artistId,
  });
  const { addAlert } = useAlert();
  const { currentUser } = useAuth();
  const { themeColors } = useWebsiteTheme();

  const [payload, setPayload] = useState();
  const [invoice, setInvoice] = useState();
  const [status, setStatus] = useState("idle");
  const [response, setResponse] = useState({});
  const [offers, setOffers] = useState([]);
  const [errMsg, setError] = useState();
  const [isLoaded, setLoaded] = useState(false);


  useEffect(() => {
    handleSign();
   
  }, []); 

  useEffect(() => {
    if (invoice) {
      getSignTxStatus(invoice, status, setStatus, setResponse);
    }
    return () => {};
  }, [invoice]);

  useEffect(() => {
    if (invoice) {
      if (status === "success" && response !== false) {
        dispatch(response);
      }
      if (status === "success" && response === false) {
        addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
        onFail();
      }
      if (status === "error") {
        addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
        onFail();
      }
    }
    return () => {};
  }, [status, invoice]);


  const handleSign = async () => {
     addAlert({
              title: type,
              type: ALERT_TYPES.INFO,
              secs: 10,
            });
    setLoaded(true)
    let isInstalled = await sdk.sync.isInstalled()
        if(isInstalled){
        
          await sdk.methods.signInAndWait().then(async ({request, response, createdAt, resolvedAt }) => {
            
                if(response?.data?.address &&
              ((currentUser?.uid &&
                currentUser?.uid === response.data?.address) ||
                !currentUser?.uid)
            ) {
              await axios
                .post(`/api/xrpl/createTransaction`, {
                  ...body,
                  sender: response?.data?.address,
                  type,
                  publicKey: response.data.publicKey,
                  txInfo: { ...body, type, publicKey: response.data.publicKey },
                  walletType: WALLET_TYPES.CROSSMARK,
                })
                .then(async (res) => {
                  if (res?.data && !res?.data?.error) {
                    setPayload(res.data.payload);
                    setInvoice(res.data.invoice);
                    setLoaded(true);
                    return await processTransaction(res.data);
                  }else{
                    addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
                    return onFail();
                  }
                  
                })
                .catch((err) => {
                  console.error(err);
                  addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
                  return onFail();
                });
            }else{
              addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
              return onFail();
            }
          });
        }else{
         return onFail(); 
        }
        
      
      
  };

  const processTransaction = async (pl) => {
    let processTx = pl.payload?.memo
      ? sdk.async.signInAndWait
      : sdk.async.signAndSubmitAndWait;
    let isInstalled = await sdk.sync.isInstalled()
      if (isInstalled) {
        await processTx(
          pl.payload?.memo
            ? pl.payload?.memo
            : pl?.payload,
        )
          .then(async ({request, response, createdAt, resolvedAt }) => {
            if(response?.data?.resp?.result || response?.data?.signature ){
              setLoaded(false);
            await updateSignTxStatus(pl.invoice, {
              txHash: !pl.payload?.memo ? response?.data?.resp?.result?.hash : false,
              signature: pl.payload?.memo ? response?.data?.signature : false,
              isOffChain: pl.payload?.memo ? true : false,
              ...response.data,
              signed: true,
            })
            ;}else{
              await updateSignTxStatus(pl.invoice, {
                          signed: false,
                        });
         addAlert({
                 title: "Transaction Rejected",
                 type: ALERT_TYPES.DANGER,
               });
                        onFail();
                        return
            }
          })
          .catch((err) => {
            console.error(err);
            setLoaded(false);
            setError(err);
          });
      } else {
        setError("No Wallet Found");
        setLoaded(false);
      }
   
  };

  const dispatch = async (response) => {
    switch (type) {
      case TRANSACTION_OPTIONS.SIGN_UP:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Sign Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Platform sign up was successful`,
        });
        return;
      case TRANSACTION_OPTIONS.SIGN_IN:
        onSuccess(response?.address);
        return;
      case TRANSACTION_OPTIONS.TIP_USER:
        addAlert({
          title: "User Tipping",
          type: ALERT_TYPES.SUCCESS,
          message: `Tipping ${body.sender.substring(
            0,
            4,
          )}...${body.sender.substring(body.sender.length - 5)} was Successful`,
        });
        onSuccess();
        return;

      case TRANSACTION_OPTIONS.SWERL_TIP:
        addAlert({
          title: "Swerl Tipper",
          type: ALERT_TYPES.SUCCESS,
          message: response?.message,
        });
        onSuccess(response?.txHash);
        return;

      case TRANSACTION_OPTIONS.ROYALTY_TRUSTLINE_SET:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Royalty Share Token Trustline",
          type: ALERT_TYPES.SUCCESS,
          message: `Royalty Share Token Trustline Set was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.SUBSCRIBE_TO_ARTIST:
        addAlert({
          title: "Artist Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Artist subscription successful`,
        });
        onSuccess();
        return;
        break;

      case TRANSACTION_OPTIONS.COMMENT:
        addAlert({
          title: "Posting Comment",
          type: ALERT_TYPES.SUCCESS,
          message: `Comment successfully posted`,
        });
        onSuccess();
        return;
        break;

      case TRANSACTION_OPTIONS.ARTIST_PROFILE_CHECKER:
        return await artistProfileChecker(response?.address)
          .then((res) => {
            return onSuccess({ ...res, address: response?.address }, body.type);
          })
          .catch((err) => {
            return onFail(err);
          });

      case TRANSACTION_OPTIONS.ARTIST_REGISTRATION:
        addAlert({
          title: "Artist Registration",
          type: ALERT_TYPES.SUCCESS,
          message: "Artist Registration Enabled",
        });
        return onSuccess(true);

      case TRANSACTION_OPTIONS.ENABLE_PUSH_NOTIFICATIONS:
        addAlert({
          title: "Push Notifications",
          type: ALERT_TYPES.SUCCESS,
          message: "Push Notifications Enabled",
        });
        return onSuccess(true);

      case TRANSACTION_OPTIONS.DISABLE_PUSH_NOTIFICATIONS:
        addAlert({
          title: "Push Notifications",
          type: ALERT_TYPES.SUCCESS,
          message: "Push Notifications Disabled",
        });

        return onSuccess(false);

      case TRANSACTION_OPTIONS.UPDATE_USER_PROFILE:
        addAlert({
          title: "Profile Update",
          type: ALERT_TYPES.SUCCESS,
          message: "User Profile Update Successful",
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.DIGITAL_SONG_PURCHASE:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Digital Song Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Song Purchase was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.DIGITAL_ALBUM_PURCHASE:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Digital Album Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Album Purchase was Successful`,
        });
        return;
      case TRANSACTION_OPTIONS.PURCHASE_MUSIC_ROYALTY:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Purchase Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.GIFT_MUSIC_ROYALTY:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Gift",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Gifting Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.CLAIM_MUSIC_ROYALTY_RESERVES:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Reserves Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Reserves Claim Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.CREATE_NFTOKEN_COLLECTION:
        onSuccess({
          name: body.title,
          mintInfo: { taxon: body.taxon },
          collectionId: response?.collectionId,
        });

        addAlert({
          title: "NFToken Collection Creation",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Collection Creation Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_PURCHASE:
        onSuccess({ offers: response?.offers, collection: body.collection });
        addAlert({
          title: "NFToken Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Purchase Was Successful`,
        });

        //insert hook before purchase
        break;

      case TRANSACTION_OPTIONS.NFTOKEN_GIFT:
        onSuccess({ ...response });
        addAlert({
          title: "Gifting NFToken",
          type: ALERT_TYPES.SUCCESS,
          message: `Gifting NFToken Was Successful`,
        });
        //insert hook before purchase
        break;

      case TRANSACTION_OPTIONS.NFTOKEN_BURN:
        addAlert({
          title: "NFToken Burn",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Burn Was Successful`,
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.NFTOKEN_TRANSFER:
        addAlert({
          title: "NFToken Transfer",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Transfer Was Successful`,
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.NFTOKEN_MINT:
        onSuccess({ ...body, tokenId: response?.tokenId });
        addAlert({
          title: "NFToken Mint",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Mint Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.UPDATE_DYNAMIC_NFTOKEN:
        onSuccess({ ...body });
        addAlert({
          title: "NFToken Update",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Update Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_OFFER_ACCEPT:
        onSuccess({
          ...response,
          collection: body?.collection,
        });
        addAlert({
          title: "NFToken(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An NFToken`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_OFFERS_ACCEPT:
        let remainingOffers = offers.filter((offer, index) => index !== 0);
        onSuccess({
          ...response,
          collection: body.collection,
          offers: remainingOffers,
        });
        addAlert({
          title: "NFToken(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An NFToken`,
        });
        return;

      case TRANSACTION_OPTIONS.SWERL_VOUCHER_OFFERS_ACCEPT:
        /*        let remainingOffers = offers.filter(
            (offer, index) => index !== 0
          ); */

        addAlert({
          title: "Vouchers(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An Voucher`,
        });
        return onSuccess({
          ...response,
          collection: body.collection,
          offers: remainingOffers,
        });

      case TRANSACTION_OPTIONS.DEACTIVATE_USER_ACCOUNT:
        return; /* deactivateUser(body, body.type, {
            txid: data.txid,
            payload: data.payload_uuidv4,
          })
            .then((data) => {
              if (!data.error || data !== false) {
                onSuccess();
                addAlert({
                  title: "User Account Deactivation",
                  type: ALERT_TYPES.SUCCESS,
                  message: `Successfully deactivated account`,
                });
                return;
              }
              addAlert({
                title: "User Account Deactivation",
                type: ALERT_TYPES.SUCCESS,
                message: `Account Deactivation Successful`,
              });
            })
            .catch((err) => {
              onFail();
              addAlert({
                title: "User Account Deactivation",
                type: ALERT_TYPES.DANGER,
                message: `Account Deactivation Unsuccessful`,
              });
            }); */

      case TRANSACTION_OPTIONS.PAY_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.PAY_AS_YOU_GO_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Pay As You Go (PAYG) Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.TOP_UP_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Streaming Subscription Top Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Top Up Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.TOP_UP_TIPPING_FUNDS:
        addAlert({
          title: "Sonar Muse Swərl Tipping Top Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Top Up Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.REDEEM_SWERL_VOUCHER:
        addAlert({
          title: "Sonar Muse Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.PURCHASE_SWERL_VOUCHER:
        addAlert({
          title: "Purchasing Swerl Streaming Voucher",
          type: ALERT_TYPES.SUCCESS,
          message: `Streaming Voucher Purchase Successful`,
        });
        return onSuccess({ offers: response.offers });

        break;

      case TRANSACTION_OPTIONS.ENABLE_WEB_MONETIZATION:
        addAlert({
          title: "Enabling Web Monetization",
          type: ALERT_TYPES.SUCCESS,
          message: `Web Monetization Successfully Enabled`,
        });
        return onSuccess({
          paymentChannel: response?.paymentChannel,
          funds: response?.funds,
        });

        break;

      case TRANSACTION_OPTIONS.AUTHORIZE_MONETIZATION_CLAIM:
        addAlert({
          title: "Authorization Receipt",
          type: ALERT_TYPES.SUCCESS,
          message: `Authorization Receipt Created Successfully`,
        });
        return onSuccess(response?.hex, response?.signer_pubkey);

        break;

      case TRANSACTION_OPTIONS.AUTHORIZE_MONETIZATION_DISABLE:
        addAlert({
          title: "Authorization Receipt",
          type: ALERT_TYPES.SUCCESS,
          message: `Authorization Receipt Created Successfully`,
        });
        return onSuccess(
          response.payload_uuidv4,
          response.txid,
          response?.hex,
          response?.data?.signer_pubkey,
        );

        break;

      case TRANSACTION_OPTIONS.CLAIM_MONETIZATION_FUNDS:
        //let address = value?.data?.address;
        addAlert({
          title: "Micropayment Funds Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Micropayments Fund Claim Successful`,
        });
        return onSuccess();
        break;

      case TRANSACTION_OPTIONS.DISABLE_WEB_MONETIZATION:
        break;

      case TRANSACTION_OPTIONS.COLLECTION_WHITELIST:
        addAlert({
          title: "Collection Whitelist",
          type: ALERT_TYPES.SUCCESS,
          message: `Collection whitelist updated successfully`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.GET_MUSIC_LIBRARY:
        //console.log(data)
        let address = response?.address;

        return onSuccess(address);

      case TRANSACTION_OPTIONS.GET_ACCOUNT_INFO:
        return onSuccess(response?.address);

      case TRANSACTION_OPTIONS.NFTOKEN_DISCOUNT:
        //console.log(data)
        return onSuccess(address);

      case TRANSACTION_OPTIONS.PODCASTER_REGISTRATION:
        break;

      case TRANSACTION_OPTIONS.MARKETING_CAMPAIGN:
        addAlert({
          title: "Marketing Campaign",
          type: ALERT_TYPES.DANGER,
          message: `Marketing Campaign Creation Successful`,
        });
        return onSuccess();

        break;

      default:
        return onSuccess(response)
        break;
    }
  };

   const refreshPage = () => {
    setPayload();
    setError();
    setInvoice();
    setResponse({});
    setLoaded(false);
    handleSign();
  };

  return (
    <>
      {!isLoaded && ((!errMsg || errMsg?.length === 0) || (status === "loading" ||status === "processing")) && (
              
                <ModalLoadingScreen
                  text={(status === "loading" || status === "processing") ? 'processing transaction. please wait' :"Loading. Please Wait..."}
                  transparent={true}
                />
             
            )}
      {isLoaded && 
        <>
                    
                      <Form action={(e) => e.preventDefault}>
                        <FormH1> {heading} </FormH1>
                        <FormText
          style={{
            fontWeight: "bold",
            marginBottom: "8px",
          }}
        >
          Please open your wallet to sign the transaction.
        </FormText>
        <FormText style={{ color: themeColors.accentColor }}>
          Keep this page open while signing.
        </FormText>

        {/* BUTTON (Acts as Manual Retry if auto-trigger missed) */}
        <FormButton
          to={"#"}
          onClick={handleSign}
          disabled={status === "processing"}
        >
          {status === "processing" ? "Processing..." : "Retry Transaction"}
          {/* isWaiting
            ? "Transaction didn't pop up? Click to Retry"
            : "Confirm & Sign" */}
        </FormButton></Form></>
    }
       {!isLoaded && errMsg?.trim()?.length > 0 && (
              <>
                <OptionModal heading={errMsg}>
                  <HoverOption onClick={refreshPage}>Try Again</HoverOption>
                  <HoverOption onClick={onCancel}>OK</HoverOption>
                </OptionModal>
              </>
            )}
    </>
  );
};

export default CrossMark;
